import request from '@/utils/request'

const url = '/home/workdiary/'
const api = {
  saveWorkdiary (data) {
    return request({
      url: url + 'saveWorkdiary',
      method: 'post',
      data
    })
  },
  Query (data) {
    return request({
      url: url + 'operationLogList',
      method: 'post',
      data
    })
  },
  handleDelete (data) {
    return request({
      url: url + 'delete',
      method: 'post',
      data
    })
  },
  changeinvoice (data) {
    return request({
      url: url + 'changeinvoice',
      method: 'post',
      data
    })
  },
  checkLogistics (data) {
    return request({
      url: url + 'checkLogistics',
      method: 'post',
      data
    })
  }
}
export default api



// WEBPACK FOOTER //
// ./src/api/workdiary.js